var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"align":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('select-bdgd-entity',{attrs:{"type":'outlined'},on:{"entitySelected":_vm.entitySelected}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }